<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 200"
          title="Статья успешно удалена."
          type="success"
          effect="dark"
        >
        </el-alert>
        <div class="row m-4">
          <div class="col-md-2">
            <h4>Статьи</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('article/create')"
              >Добавить новую статью</el-button
            >
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="6">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input
                    v-model="query.q"
                    @input="(e) => searchArticleByName(e)"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="Поиск по тэгу">
                <el-col :span="14">
                 <el-select
                    v-model="searchTags"
                    clearable
                    multiple
                    placeholder="Выберите тег"
                    class="container-article__select"
                    @change="(e) => changeTag(e)"
                  >
                    <el-option
                      v-for="item in tags"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="Поиск по категории статей">
                <el-select
                  v-model="query.article_section_id"
                  clearable
                  no-data-text="Нет данных"
                  placeholder="Сортировка"
                  @change="(e) => filterArticlesByCategory(e)"
                >
                  <el-option label="Все категории" :value="null"></el-option>
                  <el-option
                    v-for="item in getCategories"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Сортировка">
                <el-select
                  :value="query.sort.by + '.' + query.sort.order"
                  :width="300"
                  no-data-text="Нет данных"
                  placeholder="Сортировка"
                  @change="(e) => sortArticles(e)"
                >
                  <el-option
                    v-for="(item, index) in sortConfig"
                    :key="index"
                    :value="item.field"
                    :label="item.title"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="articles" style="width: 100%" empty-text="Нет данных">
          <el-table-column prop="id" label="Id" width="50"> </el-table-column>
          <el-table-column prop="title" label="Название" width="300">
          </el-table-column>
          <el-table-column prop="category" label="Категория">
            <template slot-scope="scope">
              <p v-if="articles[scope.$index].category">{{ articles[scope.$index].category.title }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="Сортировка"> </el-table-column>
          <el-table-column label="Активность">
            <template slot-scope="scope">
              <p v-if="!articles[scope.$index].activity">Нет</p>
              <p v-if="articles[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="400">
            <template slot-scope="scope">
              <el-button
                v-if="articles[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => hideRow(e, articles[scope.$index].id)"
                >Скрыть
              </el-button>
              <el-button
                v-if="!articles[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => restoreRow(e, articles[scope.$index].id)"
                >Восстановить
              </el-button>
              <el-button
                size="mini"
                @click="(e) => updateRow(e, articles[scope.$index].id)"
                >Изменить
              </el-button>
              <el-popconfirm
                :title="'Удалить эту статью?'"
                :hide-icon="true"
                :confirmButtonText="'Да'"
                :cancelButtonText="'Нет'"
                class="article-remove"
                @confirm="deleteRow(scope.row.id)"
              >
                <template #reference>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    class="el-table__row--remove-btn"
                  >
                    Удалить
                  </el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paginator ? paginator.total : 0"
          :current-page.sync="paginator.current_page"
          @current-change="onGetPage(paginator ? paginator.current_page : 0)"
          :hide-on-single-page="true"
          :page-size="paginator ? paginator.per_page : 0"
          :page-count="paginator ? paginator.last_page : 0"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/roots-sort.config";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import qs from 'qs';

export default {
  name: "Articles",
  data: function () {
    return {
      status: 0,
      articles: [],
      paginator: [],
      current: 0,
      query: {
        q: null,
        article_section_id: null,
        sort: {
          by: sortConfig[0].field.split('.')[0],
          order: sortConfig[0].field.split('.')[1]
        },
        tags: [],
        limit: 8,
      },
      tags: [],
      querySections: [],
      sortConfig,
      search: null,
      searchTimeout: null,
      searchTags: null
    };
  },
  computed: {
    getSections() {
      return this.$store.state.CatalogSections.catalogSections;
    },
    getCategories() {
      return this.$store.getters.categories
    },
    activeSort() {
      const result = this.sortConfig.find((e) => e.field === this.query.sort);
      return result ? result.options : undefined;
    },    
  },
  created() {
    this.$store.commit(SETPRELOADER_STATE, true);

    this.getArticles()
      .then((response) => {
        this.$store.commit(SETPRELOADER_STATE, false);

        const [articles, categories, tags] = response;

        this.articles = articles.data.data;
        this.tags = tags.data;

        this.paginator = articles.data.meta;

        this.$store.dispatch("setArticles", [categories.data.data, tags.data]);
      })
      .catch((error) => {
        this.$store.commit(SETPRELOADER_STATE, false);

        if (error.status === 401) {
          this.$router.push("/login");
        }
      });
  },
  methods: {
    getArticles: function () {
      const queryParams = qs.stringify(this.query, { skipNulls: true })

      return Promise.all([
        axios.get(`blog/article?${queryParams}`),
        axios.get("blog/section"),
        axios.get("blog/tag"),
      ]);
    },
    getArticlesData() {
      const queryParams = qs.stringify(this.query, {skipNulls: true})

      this.$store.commit(SETPRELOADER_STATE, true);
        
      axios
        .get(`/blog/article?${queryParams}`)
        .then((response) => {
          this.$store.commit(SETPRELOADER_STATE, false);
          this.articles = response.data.data;
          this.paginator = response.data.meta;
        })
        .catch(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    searchArticleByName(value) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
          if (!value) this.query.q = null;

          this.getArticlesData()
        }, 500);
    },
    filterArticlesByCategory(idCategory) {
      this.article_section_id = idCategory;
      this.$store.commit(SETPRELOADER_STATE, true);

      this.getArticlesData()
    },
    sortArticles: function (sortName) {
      this.query.sort.by = sortName.split('.')[0];
      this.query.sort.order = sortName.split('.')[1];

      this.getArticlesData()
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    hideRow(e, idArticle) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";
      axios
        .post(`blog/article/${idArticle}/hide`)
        .then(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";

          this.articles = [
            ...this.articles.map((el) => {
              if (el.id === idArticle) {
                el.activity = false;
              }

              return el;
            }),
          ];
        })
        .catch(() => {
          btn.style.pointerEvents = "all";
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    restoreRow(e, idArticle) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post(`blog/article/${idArticle}/restore`)
        .then(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.articles = [
            ...this.articles.map((el) => {
              if (el.id === idArticle) {
                el.activity = true;
              }

              return el;
            }),
          ];
        })
        .catch(() => {
          btn.style.pointerEvents = "all";
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    updateRow(e, idArticle) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);
      btn.style.pointerEvents = "none";

      const articleData = axios.get(`blog/article/${idArticle}`);
      const aticleProductData = axios.get(`blog/article/${idArticle}/product`)

      Promise.all([articleData, aticleProductData]).then((response) => {
        this.$store.dispatch("fetchCurrentArticle", response);
        this.$router.push(`/article/${idArticle}/update`);
      }).finally(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";
      })
    },
    deleteRow(idArticle) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);
      
      axios
        .delete(`blog/article/${idArticle}`)
        .then(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.articles = this.articles.filter((el) => el.id !== idArticle);
        })
        .catch(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    changeTag(value) {
      this.query.tags = [...value]

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.getArticlesData()
      }, 700)
    },
    goToPage: function (path) {
      this.$router.push(path);
    },
    onGetPage(page) {
      if (page !== null) {
        this.$store.commit(SETPRELOADER_STATE, true);

        const queyParams = qs.stringify(this.query, {skipNulls: true}); 
        
        axios
          .get(`/blog/article?page=${page}&${queyParams}`)
          .then((response) => {
            this.paginator = response.data.meta;
            this.articles = response.data.data; 
            this.current = response.data.meta.current_page;
          })
          .catch((errors) => {
            if (errors.response.status === 401) {
              this.$router.push("/login");
            }
          }).finally(() => {
            this.$store.commit(SETPRELOADER_STATE, false);  
          });
      }
    },
  },
};
</script>

<style scoped>
.article-remove {
  margin-left: 10px;
}

p {
  margin-bottom: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>